import * as React from 'react'
import AccessibleFormLabel from './AccessibleFormLabel'
import { Input, FormControl, IconButton } from '@mui/joy'
import { Visibility, VisibilityOff } from '@mui/icons-material'
import { useState } from 'react'
import Errors from './Errors'
import useTranslation from '../../shared/TranslationProvider'

const PasswordInput = ({
  password,
  setPassword,
  required = true,
  size = 'lg',
  labelValue = 'Password',
  name = 'password',
  errors,
  className,
  isWhiteText,
  ...props
}) => {
  const { t } = useTranslation()
  const [showPassword, setShowPassword] = useState(false)

  const hasError = errors && errors[name] && errors[name].length > 0

  return (
    <FormControl required={required} error={hasError} className={className}>
      <AccessibleFormLabel isWhiteText={isWhiteText}>
        {labelValue}
      </AccessibleFormLabel>
      <Input
        name={name}
        size={size}
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        type={showPassword ? 'text' : 'password'}
        endDecorator={
          // CTS-9259 (YNS-007): dynamic name + aria-pressed for show/hide state.
          // CTS-9216 (YNS-008): Visibility / VisibilityOff icons — not color-only state.
          <IconButton
            sx={{ '--joy-palette-success-plainColor': '#0088FF' }}
            color={showPassword ? 'success' : 'neutral'}
            aria-label={showPassword ? t('hide_password') : t('show_password')}
            aria-pressed={showPassword}
            onClick={() => {
              setShowPassword(!showPassword)
            }}
            onMouseDown={(e) => e.preventDefault()}
          >
            {showPassword ? <VisibilityOff /> : <Visibility />}
          </IconButton>
        }
        {...props}
      />
      <Errors errors={errors} field={name} />
    </FormControl>
  )
}

export default PasswordInput
